module.exports = "../content/9ece5b48963bbc96309220952cda38aa.ttf";